import axios from 'axios'
import APIConfig from '@/data/remote/APIConfig.js'

export default class WorkOrderService {
    constructor() {
        this.apis = {
            getAll: () => axios.get(APIConfig.APIURL + '/workOrder'),
            add: (payload) => axios.post(APIConfig.APIURL + '/workOrder', payload),
            edit: (id, payload) => axios.put(APIConfig.APIURL + `/workOrder/${id}`, payload),
            inActivate: (id) => axios.post(APIConfig.APIURL + `/workOrder/${id}/inactivate`),
            // delete: (id) => axios.delete(APIConfig.APIURL + `/workOrder/${id}`),
            reject: (id, payload) => axios.post(APIConfig.APIURL + `/workOrder/${id}/reject`, payload),
            submit: (id, payload) => axios.post(APIConfig.APIURL + `/workOrder/${id}/submit`, payload),
            close: (id, payload) => axios.post(APIConfig.APIURL + `/workOrder/${id}/close`, payload),
            approve: (id, payload) => axios.post(APIConfig.APIURL + `/workOrder/${id}/approve`, payload),
            report: (id, payload) => axios.post(APIConfig.APIURL + `/workOrder/${id}/report`, payload),
            signBudget: (id, payload) => axios.post(APIConfig.APIURL + `/workOrder/${id}/sign-budget`, payload),
            signReward: (id, payload) => axios.post(APIConfig.APIURL + `/workOrder/${id}/sign-reward`, payload),
        }
    }

    prepareData(vm) {
        return new Promise((resolve, reject) => {
            if (vm.$store.state.workOrder.isFetched) {
                resolve(vm.$store.state.workOrder.list)
                return
            }
            if (vm.$store.state.workOrder.isFetching) {
                var timer = setInterval(() => {
                    if (vm.$store.state.workOrder.isFetching) return
                    clearInterval(timer)
                    if (vm.$store.state.workOrder.isFetched) {
                        resolve(vm.$store.state.workOrder.list)
                    } else {
                        reject('無法取得資料，請嘗試重新整理')
                    }
                }, 500)
                return
            }
            return this.getAll(vm)
                .then(res => {
                    vm.$store.state.workOrder.isFetched = true
                    vm.$store.state.workOrder.isReloaded = false
                    vm.$store.state.workOrder.list = res.data.result || []
                    return res
                })
                .then(res => {
                    vm.$store.state.workOrder.isFetching = false
                    resolve()
                    return res
                })
                .catch(err => {
                    vm.$store.state.workOrder.isFetching = false
                    reject(err)
                })
        })
    }

    getAll(vm) {
        return new Promise((resolve, reject) => {
            this.apis.getAll()
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    add(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.add(payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    edit(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.edit(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    inActivate(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.inActivate(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    delete(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.delete(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    reject(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.reject(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    submit(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.submit(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    close(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.close(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    approve(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.approve(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    report(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.report(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    signReward(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.signReward(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    signBudget(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.signBudget(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }
}
